var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"normal_card"},[_c('a',{staticClass:"normal_card_a",attrs:{"tag":"a","target":"_blank","href":_vm.data.html_url}},[_c('img',{staticClass:"normal_card_img",attrs:{"src":_vm.data.picture_url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }